import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon, Box as Row, toast } from '@node-space/ui-components'
import { copyToClipboard } from 'utils/utils'

interface PaymentLinkActionsProps {
  link: string
  openLinkText: string
  copyLinkText: string
}

export const PaymentLinkActions = ({
  link,
  openLinkText,
  copyLinkText,
}: PaymentLinkActionsProps) => {
  const { t } = useTranslation()

  return (
    <Row flex className="mt-4 gap-x-4">
      <Button
        variant="ghost"
        noPadding
        iconElement={<Icon name="ArrowSquareOut" />}
        onClick={() => {
          if (link) {
            window.open(link)
          }
        }}
      >
        {openLinkText}
      </Button>
      <Button
        variant="ghost"
        noPadding
        iconElement={<Icon name="Copy" />}
        onClick={() => {
          if (link) {
            copyToClipboard(link)
            toast({ header: `${t('copiedToClipboard')}`, variant: 'success' })
          }
        }}
      >
        {copyLinkText}
      </Button>
    </Row>
  )
}
